import fetchWithOptions from '../../../shared/utils/fetch';
import { ServerWave, Wave } from '../../wave/types/wave.type';
import {
  appendTags,
  generateWaveId,
  getLinkedWaves,
  getWaveType,
} from '../../wave/utils/wave.util';

export const getDelineation = async (
  ecgId: string,
  delineationId: number,
): Promise<Wave[]> => {
  try {
    const waves = await fetchWithOptions<ServerWave[]>(
      `/api/ecg/${ecgId}/delineation/${delineationId}`,
    );

    return jsonToWaves(waves);
  } catch {
    return [];
  }
};

export const jsonToWaves = (waves: ServerWave[]): Wave[] => {
  return getLinkedWaves(waves.map(jsonToWave));
};

const jsonToWave = (
  wave: ServerWave,
  index: number,
  serverWaves: ServerWave[],
): Wave => {
  if (wave.onset == null && wave.type === 'T') {
    const previousWave = serverWaves[index - 1];
    wave.onset = previousWave?.type === 'QRS' ? previousWave.offset : 0;
  }

  return {
    ...wave,
    type: getWaveType(wave),
    id: generateWaveId(),
    background: false,
  };
};

export const saveDelineation = async (
  ecgId: string,
  waves: Wave[],
): Promise<boolean> => {
  try {
    await fetchWithOptions(`/api/ecg/${ecgId}/delineation`, {
      method: 'PUT',
      body: JSON.stringify({ delineation: parseToServerWave(waves) }),
    });
    return true;
  } catch {
    return false;
  }
};

const parseToServerWave = (waves: Wave[]): ServerWave[] =>
  waves.map((wave): ServerWave => {
    switch (wave.type) {
      case 'artifact':
      case 'calibration':
      case 'noise':
      case 'no_signal':
      case 'p_level_noise':
      case 'qrs_level_noise':
      case 'pt_level_noise':
      case 'uncertain':
      case 'microvolted':
        return {
          onset: wave.onset,
          offset: wave.offset,
          tags: appendTags(wave.tags, wave.type),
          type: 'INV',
        };
      case 'QRS':
      case 'P':
      case 'T':
      default:
        return {
          onset: wave.onset,
          offset: wave.offset,
          tags: wave.tags,
          type: wave.type,
        };
    }
  });
